import { render, staticRenderFns } from "./ParceiroListFiltro.vue?vue&type=template&id=04df886d"
import script from "./ParceiroListFiltro.vue?vue&type=script&lang=js"
export * from "./ParceiroListFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports